import { render, staticRenderFns } from "./RoundTab.vue?vue&type=template&id=9eaa1ea4"
import script from "./RoundTab.vue?vue&type=script&lang=js"
export * from "./RoundTab.vue?vue&type=script&lang=js"
import style0 from "./RoundTab.vue?vue&type=style&index=0&id=9eaa1ea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports